import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function TwoDecadesOfConcreteExcellence() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const stats = [{
    value: "20",
    label: "Years Experience"
  }, {
    value: "1200",
    label: "Projects Completed"
  }, {
    value: "150",
    label: "Homes Renovated"
  }];
  return <section id="two-decades-of-concrete-excellence" className="py-20 md:py-32 bg-background overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={ref} className={cn("grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
          {}
          <div className="relative flex flex-col gap-6 lg:pr-12">
            {}
            <div className="absolute -left-12 top-1/4 w-64 h-64 bg-primary/5 rounded-full blur-3xl -z-10" />
            
            <div className="relative h-64 md:h-80 w-full md:w-[90%] self-start overflow-hidden rounded-sm shadow-xl border-l-4 border-primary">
              <img src="https://awaited-badger.10web.cloud/wp-content/uploads/2026/03/3.jpg" alt="Close-up of craftsman hands finishing concrete" className="h-full w-full object-cover hover:scale-105 transition-transform duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-60" />
            </div>
            
            <div className="relative h-64 md:h-80 w-full md:w-[90%] self-end overflow-hidden rounded-sm shadow-xl border-r-4 border-primary mt-[-2rem] md:mt-[-4rem] z-10">
              <img src="https://awaited-badger.10web.cloud/wp-content/uploads/2026/03/2.jpg" alt="Wide shot of a completed commercial concrete floor" className="h-full w-full object-cover hover:scale-105 transition-transform duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-60" />
            </div>
          </div>

          {}
          <div className="flex flex-col justify-center">
            <div className="mb-8">
              <Badge variant="default" className="bg-primary text-primary-foreground hover:bg-primary/90 text-sm font-bold px-4 py-1.5 rounded-sm uppercase tracking-widest mb-6 w-fit">20 YEARS EXPERIENCE</Badge>
              <h2 className="text-4xl md:text-5xl font-serif font-bold text-foreground mb-6 tracking-tight leading-[1.1]">
                Concrete Built to Last in Central & Northern Indiana
              </h2>
              <p className="text-xl text-muted-foreground leading-relaxed">DSC Concrete is a locally owned residential and commercial concrete contractor serving Central and Northern Indiana with nearly 20 years of experience. We deliver high-quality craftsmanship, bringing clients’ visions to life with durable, Midwest-ready construction that stands the test of time.</p>
            </div>

            {}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 border-t border-border pt-10">
              {stats.map((stat, i) => <div key={i} data-index={i} className="flex flex-col">
                  <div className="flex items-baseline gap-1 mb-2">
                    <span className="text-4xl md:text-5xl font-bold text-foreground font-serif">
                      {stat.value}
                    </span>
                    <span className="text-3xl md:text-4xl font-bold text-primary">
                      +
                    </span>
                  </div>
                  <span className="text-sm font-medium text-muted-foreground uppercase tracking-wider">
                    {stat.label}
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}